import React, { PropsWithChildren } from "react";
import { ShareDrawer } from "@bloomberg/media-ui-icons";
import { OutlinedButton } from "@bloomberg/media-ui-core";
import { useFileExport } from "~hooks/useFileExport";
import type { ExportOptions } from "~utils/fileTransfer";

type ExportButtonProps = {
  options: ExportOptions;
  /** base name for the downloaded file (will add .csv or .xlsx) */
  outputName?: string;
  className?: string;
  type: "csv" | "xlsx";
  title?: string;
  disabled?: boolean;
};

export function ExportButton(props: PropsWithChildren<ExportButtonProps>) {
  const {
    options,
    type,
    children,
    outputName = "export",
    className = "",
    title = "Export data",
    disabled = false,
  } = props;

  const exportFile = useFileExport(outputName);

  const handleExport = () => {
    exportFile(options, type);
  };

  return (
    <OutlinedButton
      className={className}
      Icon={<ShareDrawer />}
      iconPosition="left"
      onClick={handleExport}
      disabled={disabled}
      title={title}
      size="default"
      version="phoenix"
      fullWidth
    >
      {children}
    </OutlinedButton>
  );
}
